import { useTheme } from '@mui/material';

export const EmailSuccessIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={30} height={31} fill="none">
            <path
                fill={primaryStroke}
                d="M4.242 6.45a2.743 2.743 0 0 0-2.728 3H1.5v12c0 1.654 1.345 3 3 3h9.066a9.053 9.053 0 0 1-.535-1.5H4.5c-.83 0-1.5-.67-1.5-1.5v-9.77l8.283 6.076a3.74 3.74 0 0 0 1.753.698 8.69 8.69 0 0 1 .52-1.472c-.483.01-.97-.136-1.383-.436L3.506 10.19a1.244 1.244 0 0 1 .736-2.245l18.258.004c.83 0 1.5.67 1.5 1.5v2.532a9.05 9.05 0 0 1 1.5.534V9.45c0-1.654-1.345-3-3-3H4.242Zm17.508 9a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5Zm0 12a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5Zm2.69-9.605a.755.755 0 0 0-1.05.164l-2.484 3.417-1.256-1.256a.753.753 0 0 0-1.06 0 .753.753 0 0 0 0 1.06l1.876 1.874c.154.155.37.235.59.216a.769.769 0 0 0 .549-.305l3-4.125a.755.755 0 0 0-.164-1.05v.005Z"
            />
            <path
                fill={primaryBackground}
                d="M4.5 12a3 3 0 0 1 3-3h17a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-17a3 3 0 0 1-3-3V12Z"
            />
        </svg>
    );
};
